import React, { memo } from 'react';

import InputSearch, { InputSize } from '@zvuk-b2b/react-uikit/ui/InputSearch';
import Popper, { HintPlacement } from '@zvuk-b2b/react-uikit/ui/Popper';
import Switcher, { LabelPlacement } from '@zvuk-b2b/react-uikit/ui/Switcher';
import IconInfo from '@zvuk-b2b/react-uikit/ui/icons/Info';

import { EXACT_SEARCH_TOOLTIP_OFFSET } from '../consts';
import type { TagFilterDropdownProps } from '../types';
import TagFilterOption from './TagFilterOption';

import styles from '../index.module.scss';

const TagFilterDropdown: React.FC<TagFilterDropdownProps> = ({
  dropdownRef,
  isExactSearch,
  selectedTagIds,
  tagSearch,
  tags,
  texts,
  testIds,
  onExactSearchChange,
  onSearchChange,
  onTagChange,
}) => (
  <div
    ref={dropdownRef}
    className={styles.dropdown}
    role="dialog"
    aria-label={texts.filterButtonLabel}
    data-testid={testIds.dropdown}>
    <InputSearch
      elementId={testIds.tagSearch}
      value={tagSearch}
      placeholder={texts.tagSearchPlaceholder}
      size={InputSize.SMALL}
      containerClassName={styles.tagSearch}
      inputClassName={styles.searchInput}
      onChange={onSearchChange}
    />

    <div className={styles.exactSearch}>
      <Switcher
        elementId={testIds.exactSwitcher}
        labelPlacement={LabelPlacement.RIGHT}
        labelClassName={styles.exactSearchSwitcherLabel}
        isChecked={isExactSearch}
        onChange={onExactSearchChange}>
        <span className={styles.exactSearchLabel}>
          {texts.exactSearch}
          <Popper
            elementId={testIds.exactTooltip}
            popperClassName={styles.tooltipPopper}
            placement={HintPlacement.PLACEMENT_TOP}
            offset={EXACT_SEARCH_TOOLTIP_OFFSET}
            portalNode={document.body}
            triggerNode={
              <span
                aria-label={texts.exactSearchInfoLabel}
                data-testid={testIds.exactInfo}>
                <IconInfo className={styles.infoIcon} />
              </span>
            }>
            <span className={styles.tooltip}>{texts.exactSearchTooltip}</span>
          </Popper>
        </span>
      </Switcher>
    </div>

    <ul className={styles.tagList}>
      {tags.map((tag) => (
        <TagFilterOption
          key={tag.id}
          isChecked={selectedTagIds.has(tag.id)}
          tag={tag}
          testIds={testIds}
          onChange={onTagChange}
        />
      ))}
    </ul>
  </div>
);

export default memo(TagFilterDropdown);
